import React from 'react';

import { RectShape, TextRow } from 'react-placeholder/lib/placeholders';

const CustomProductListItemPlaceholder = () => (
  <div className="relative flex flex-col">
    <div className="aspect-square">
      <RectShape
        style={{
          width: '100%',
          height: '100%',
        }}
        className="placeholder-loader"
      />
    </div>

    <TextRow
      className="placeholder-loader"
      color="inherit"
      style={{ width: '50%', height: '20px' }}
    />

    <TextRow
      className="placeholder-loader"
      color="inherit"
      style={{ width: '20%', height: '15px' }}
    />
  </div>
);

export default CustomProductListItemPlaceholder;
